/**
 * Authentication utilities for API requests
 */

// Setup fetch interceptor for automatic token inclusion
const originalFetch = window.fetch;

window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const token = localStorage.getItem('token');

  // Check if request is for S3
  const urlString = input instanceof Request ? input.url : input.toString();
  const isS3Request = urlString.includes('amazonaws.com');

  // Add authorization header if token exists and NOT an S3 request
  if (token && !isS3Request) {
    if (init) {
      init.headers = {
        ...init.headers,
        'Authorization': `Bearer ${token}`,
      };
    } else {
      init = {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      };
    }
  }

  const response = await originalFetch(input, init);

  // Handle 401 responses (token expired)
  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('username');

    // Only redirect if we're on a protected page (not public marketing pages)
    const currentPath = window.location.pathname;
    const publicPaths = ['/', '/login', '/signup', '/about', '/pricing', '/contact', '/products', '/privacy', '/terms'];
    const isPublicPath = publicPaths.some(path => currentPath === path || currentPath.startsWith(path + '/'));

    // Redirect to login only if on a protected page (dashboard, settings, etc)
    if (!isPublicPath && (currentPath.startsWith('/dashboard') || currentPath.startsWith('/settings') || currentPath.startsWith('/appointments'))) {
      window.location.href = '/login';
    }
  }

  return response;
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem('token');
};

export const isAuthenticated = (): boolean => {
  const token = getAuthToken();
  return !!token;
};

export const logout = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('access_token');
  localStorage.removeItem('username');
  window.location.href = '/';
};

export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};
